module.exports={
    "两次输入的密码必须一致": "Las contraseñas no se coinciden",
    "取消": "Cancelar",
    "如验证出现问题，请点击": "Error de verificacion",
    "如验证出现问题，请联系orcalivecs@asiainnovations.com": "Si sucede error de verificacion, por favor comunica con orcalivecs@asiainnovations.com",
    "如验证出现问题，请联系upcs@asiainnovations.com": "Si sucede error de verificacion, por favor comunica con upcs@asiainnovations.com",
    "密码修改成功": "Ha cambiado tu contraseña exitosamente",
    "密码格式错误": "Error de formato",
    "密码由6-20位由数字和字母组成": "Contraseña debe contener una letra y un numero, la longitud entre 6-20 caracteres",
    "恭喜您密码重置成功": "Ha cambiado tu contraseña exitosamente",
    "恭喜您已成功激活帐户": "Has activado tu cuenta!",
    "知道了": "Si",
    "确认修改": "Confirmar modificacion",
    "网络连接有误, 请稍后再试": "Error de conexión, por favor renintenta de nuevo",
    "联系客服": "Soporte al clientes",
    "请再次输入密码": "Confirmar la contraseña",
    "请返回UpVoice中重新进行邮箱验证": "Vuelve al Upvoice para verificar email",
    "请返回Up直播中重新进行邮箱验证": "Vuelve al Uplive para verificar email",
    "请返回虎鲸直播中重新进行邮箱验证": "Vuelve al Orcalive para verificar email",
    "请重新设定登录密码": "Cambiar la contraseña",
    "请重新设置密码": "Cambiar la contraseña",
    "赶快返回UpVoice中与全球潮人互动吧": "Vuelve al UpVoice, empezamos la fiesta!",
    "赶快返回Up直播中与全球潮人互动吧！": "Vuelve al Uplive, empezamos la fiesta!",
    "赶快返回虎鲸直播中与全球潮人互动吧": "Vuelve al Orcalive, empezamos la fiesta!",
    "重置密码失败": "Error al cambiar contraseña",
    "验证失败": "Error de verificacion",
    "验证成功": "Verificacion exitosa!"
};


// WEBPACK FOOTER //
// ./js/lang/eses.js